
import { HttpEvent } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { LoggerService } from './../logger/logger.service';
import { Injectable, inject } from '@angular/core';

@Injectable()
/** Service to handle Error */
export class ErrorHandlerService {
  private readonly logger = inject(LoggerService);


  /* #region Public Methods */
  /** Method to handle error and add it in logs */
  public handleError(httpError: any): Observable<HttpEvent<any>> {
  let errorMessage = `An error occurred: ${httpError.status} - ${httpError.statusText}`;
  if (httpError.error) {
    const errorDetail = httpError.error.detail || httpError.error.Detail;

    if (httpError.status === 403) {
      httpError.status = 403;
      errorMessage = httpError;
    }
    else if (httpError.error.ExceptionMessage) {
      errorMessage = `${errorMessage} - ${httpError.error.ExceptionMessage}`;
    }
    else if (
      httpError.error.Status === 401 &&
      errorDetail?.startsWith("Invalid Access Token/Access denied to the API")
    ) {
      httpError.status = 403;
      errorMessage = httpError;
    }
    else {
      errorMessage = httpError;
    }
  }

  this.logger.error(errorMessage);
  return observableThrowError(errorMessage);
}
  /* #endregion */
}
